import { useSelector } from "react-redux";
import { useLayoutEffect } from "react";
import { NavLink } from "react-router-dom";

import { Drawer } from "antd";
import { CloseOutlined } from "@ant-design/icons";

import useTranslation from "../../hooks/useTranslation";

import TEXT from "../../config/text";
import PATHS from "../../config/paths";

import style from "../style/navbar.module.scss";
import { RESELLER_HOST } from "../../config";

const NavDrawer = ({ visible, onClose }) => {
  const translation = useTranslation();

  const { widgets } = useSelector((state) => state.globalState);
  const isAdmin = useSelector((store) => store.globalState.isAdmin);

  const handleText = (page, text) => {
    if (translation?.pages?.[page]?.[text]) {
      return translation?.pages?.[page]?.[text];
    }

    return TEXT?.pages?.[page]?.[text];
  };

  useLayoutEffect(() => {
    document.body.style.overflow = visible ? "hidden" : "unset";
  }, [visible]);

  return (
    <Drawer
      placement="left"
      onClose={onClose}
      open={visible}
      bodyStyle={{ padding: 0 }}
      headerStyle={{ display: "none" }}
    >
      <div className={style["nav-drawer"]}>
        <CloseOutlined
          style={{
            position: "absolute",
            right: "29px",
            top: "23px",
            color: "#d3caca",
            fontSize: "19px",
            cursor: " pointer",
          }}
          onClick={onClose}
        />
        <NavLink onClick={onClose} to={PATHS.HOME}>
          {handleText("home", "page_name")}
        </NavLink>
        {widgets &&
          widgets.hide_activation_page &&
          widgets.hide_activation_page.enabled &&
          widgets.hide_activation_page.enabled === "false" && (
            <NavLink onClick={onClose} to={PATHS.ACTIVATION}>
              {handleText("activation", "page_name")}
            </NavLink>
          )}

        {widgets &&
          widgets.hide_upload_playlist &&
          widgets.hide_upload_playlist.enabled &&
          widgets.hide_upload_playlist.enabled === "false" && (
            <NavLink onClick={onClose} to={PATHS.UPLOAD_PLAYLIST}>
              {handleText("upload_playlist", "page_name")}
            </NavLink>
          )}


        {widgets?.news?.enabled === "true" && (
          <NavLink to={PATHS.NEWS} onClick={onClose}>
            {handleText("news", "page_name")}
          </NavLink>
        )}

        {widgets?.pricing?.enabled === "true" && (
          <NavLink to={PATHS.PRICING} onClick={onClose}>{handleText("pricing", "page_name")}</NavLink>
        )}

        {widgets?.support?.enabled === "true" && (
          <NavLink to={PATHS.CONTACT_US} onClick={onClose}>
            {handleText("contact_us", "page_name")}
          </NavLink>
        )}
        {
          widgets &&
          widgets.installation_guide &&
          widgets.installation_guide.enabled &&
          widgets.installation_guide.enabled === "true" &&
          <NavLink to={PATHS.INTALLATION_GUIDE} onClick={onClose}>
            {handleText("installation_guide", "page_name")}
          </NavLink>
        }

        {widgets?.referral?.enabled === "true" &&
          widgets?.reseller?.enabled === "true" && (
            <NavLink onClick={onClose} to={PATHS.RESELLER}>
              {handleText("register", "register")}
            </NavLink>
          )}

        {
          widgets?.referral?.enabled === "true" &&
          widgets?.reseller?.enabled === "true" && <a
            onClick={onClose}
            target="_blank"
            rel="noreferrer"
            href={RESELLER_HOST}
          >
            {handleText("register", "reseller_login")}
          </a>

        }

        {isAdmin && (
          <NavLink
            to={PATHS.CHAT}
            className={({ isActive }) =>
              isActive
                ? `${style["menu-list__item__link"]} ${style["active-link"]}`
                : style["menu-list__item__link"]
            }
          >
            {handleText("chat", "page_name")}
          </NavLink>
        )}
      </div>
    </Drawer>
  );
};

export default NavDrawer;
